import { DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useRouter } from 'next/router';
import { FormattedMessage } from 'react-intl';

import { SiteLocale } from 'constants/i18n.constants';
import { useLocale } from 'hooks/useLocale';

import BorderStack from 'components/@common/BorderStack';
import LinkUnstyled from 'components/@common/LinkUnstyled';
import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';
import Icon from 'components/@icons/Icon';

interface Props {
  open: boolean;
  onClose: () => void;
}

const LanguagePickerDialog = ({ open, onClose }: Props) => {
  const { updateLocale, locale: activeLocale } = useLocale();
  const { asPath } = useRouter();

  const handleChangeLanguage = (locale: SiteLocale) => {
    updateLocale(locale);
    onClose();
  };

  return (
    <ResponsiveDrawerDialog isOpen={open} onClose={onClose}>
      <DialogTitle>
        <FormattedMessage id="account.settings.change.language.title" />
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            gap: 1,
          }}
        >
          {Object.values(SiteLocale).map((locale) => (
            <BorderStack
              key={locale}
              component={LinkUnstyled}
              href={asPath}
              locale={locale}
              hrefLang={locale}
              lang={locale}
              onClick={() => handleChangeLanguage(locale)}
              sx={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderColor:
                  activeLocale === locale ? 'text.secondary' : 'grey.800',
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 'bold',
                  color: 'text.primary',
                }}
              >
                <FormattedMessage id={`locales.${locale}.label`} />
              </Typography>
              {activeLocale === locale ? (
                <Icon name="Check" color="global01.400" />
              ) : (
                <Icon name="ChevronRight" rotateInArabic color="text.primary" />
              )}
            </BorderStack>
          ))}
        </Stack>
      </DialogContent>
    </ResponsiveDrawerDialog>
  );
};

export default LanguagePickerDialog;
